<template>
  <canvas id="chartjs-canvas"></canvas>
</template>

<script>
  import Chart from "chart.js";

  export default {
    props: ["chartdata", "options"],
    data() {
      return { chart: null };
    },
    methods: {
      renderChart() {
        var ctx = document.getElementById("chartjs-canvas").getContext("2d");
        this.chart = new Chart(ctx, {
          type: "line",
          data: this.chartdata,
          options: this.options,
        });
      },
    },
    watch: {
      chartdata: function() {
        this.renderChart();
      },
    },
  };
</script>

<style></style>
